import { fromJS, Map } from 'immutable';
import {
  reviewOrderToggle,
  setValidationError,
  setOrderDetails,
  clearOrderDetails,
  setOneTimeAddress,
  setCompSapAddress,
  setBillableSapAddress,
  isSubmittingToggle,
  hasSubmittedToggle,
  clearAllSelectedAddresses,
  clearBillableSapAddress,
  clearCompSapAddress,
  clearOneTimeAddress
} from './actions';

export const defaultState = Map({
  revieworder: false,
  validationError: '',
  order: {
    orderNumber: null,
    shippingMethod: null,
    notes: null,
    phone: null,
    ext: null,
    address: null,
    checkoutOptions: null
  },
  oneTimeAddress: null,
  compSapAddress: null,
  billableSapAddress: null,
  isSubmitting: false,
  hasSubmitted: false
});

export default function checkout(state = defaultState, action) {
  const newState = fromJS(state); // Force immutable in case of rehydration

  switch (action.type) {
    case reviewOrderToggle.type:
      return newState.set('revieworder', !newState.get('revieworder'));
    case setValidationError.type:
      return newState.set('validationError', action.payload);
    case setOrderDetails.type:
      return newState.set('order', action.payload);
    case clearOrderDetails.type:
      return newState.set('order', defaultState.get('order'));
    case setOneTimeAddress.type:
      if (action.payload) return newState.set('oneTimeAddress', action.payload);
      return newState;
    case setCompSapAddress.type:
      return newState.set('compSapAddress', action.payload);
    case setBillableSapAddress.type:
      return newState.set('billableSapAddress', action.payload);
    case isSubmittingToggle.type:
      return newState.set('isSubmitting', !newState.get('isSubmitting'));
    case hasSubmittedToggle.type:
      return newState.set('hasSubmitted', !newState.get('hasSubmitted'));

    case clearAllSelectedAddresses.type:
      return newState
        .set('compSapAddress', defaultState.get('compSapAddress'))
        .set('billableSapAddress', defaultState.get('billableSapAddress'))
        .set('oneTimeAddress', defaultState.get('oneTimeAddress'));
    case clearOneTimeAddress.type:
      return newState.set('oneTimeAddress', defaultState.get('oneTimeAddress'));
    case clearCompSapAddress.type:
      return newState.set('compSapAddress', defaultState.get('compSapAddress'));
    case clearBillableSapAddress.type:
      return newState.set('billableSapAddress', defaultState.get('billableSapAddress'));

    default:
      return newState;
  }
}

export const reviewOrder = state => state.checkout.get('revieworder');
export const order = state => state.checkout.get('order');
export const oneTimeAddress = state => state.checkout.get('oneTimeAddress');
export const compSapAddress = state => state.checkout.get('compSapAddress');
export const billableSapAddress = state => state.checkout.get('billableSapAddress');
export const validationError = state => state.checkout.get('validationError');
export const isSubmitting = state => state.checkout.get('isSubmitting');
export const hasSubmitted = state => state.checkout.get('hasSubmitted');
